<template>
  <basic-dialog :show="show" @close="$emit('close')" :max-width="maxWidth">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col :cols="numCol" v-for="f in fields" :key="f.name">
        <v-row>
          <v-col class="py-0">
            <v-container>
              <v-row>
                <v-checkbox v-model="f.selected"></v-checkbox>
                <v-text-field
                  v-if="f.type == 'STRING'"
                  v-model="f.value"
                  :label="f.label"
                  hide-details
                  :disabled="!f.selected"
                  :outlined="outlinedInputs"
                ></v-text-field>
                <v-text-field
                  v-if="f.type == 'NUMBER'"
                  v-model.number="f.value"
                  :label="f.label"
                  hide-details
                  type="number"
                  :disabled="!f.selected"
                  :outlined="outlinedInputs"
                />
                <v-switch
                  v-if="f.type == 'BOOLEAN'"
                  v-model="f.value"
                  :label="f.label"
                  hide-details
                  :disabled="!f.selected"
                />
                <date-picker
                  v-if="f.type == 'DATE'"
                  v-model="f.value"
                  :customLabel="f.label"
                  hide-details
                  :disabled="!f.selected"
                  :outlined="outlinedInputs"
                />
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-alert type="warning">
          Changes made in the batch update can not be reversed.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ updateFields }}</code>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onUpdate" :disabled="!isValid"
        >Update</v-btn
      >
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "./BasicDialog.vue";
import DatePicker from "./DatePicker.vue";
export default {
  components: { BasicDialog, DatePicker },
  name: "batch-update-dialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editorTitle: {
      type: String,
      default: "Batch Update",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    maxWidth: {
      type: String,
      default: () => "1200",
    },
  },

  data() {
    return {
      debug: false,
      numCol: 4,
      fields: this.columns.map((col) => {
        return {
          name: col.name,
          value: col.type == "BOOLEAN" ? false : "",
          type: col.type,
          selected: false,
          label: col.label,
        };
      }),
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    updateFields() {
      return this.fields
        .filter((f) => f.selected)
        .map((f) => ({
          name: f.name,
          value: f.type == "NUMBER" ? Number(f.value) : f.value,
        }));
    },
    isValid() {
      return this.updateFields.length > 0;
    },
  },

  methods: {
    onUpdate() {
      this.$emit("update", this.updateFields);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/BatchUpdateDialog.vue